import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import BsModal from "../../Misc/BsModal";
import DefaultNotFound from "../../Misc/DefaultNotFound";

export default class ElementAllOperation extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      list: {},
      pending: false,
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      if (this.props.show) this.load();
    }
  }

  load = async () => {
    const { shipId } = this.props;

    this.setState({ pending: true });
    let list = {};
    if (shipId && shipId !== "any") {
      let elementList = await this.context.api.qa("/element/list", {
        fields: ["id", "label", "operating", "modelname"],
        filter: { ship: shipId, operating: true },
        orderby: ["label ASC"],
      });

      elementList.forEach((item) => {
        list[item.id] = {
          modelname: item.modelname,
          label: item.label,
          value: 0,
        };
      });

      if (elementList.length > 0) {
        let operationList = await this.context.api.qa(
          "/element/operating/time/list",
          {
            orderby: ["validfromdate ASC"],
            fields: ["element", "value"],
            search: [
              {
                field: "element",
                valarr: Object.keys(list),
              },
            ],
          }
        );
        operationList.forEach((item) => {
          list[item.element].value = item.value;
        });
      }
    }
    this.setState({ pending: false, list: list || {} });
  };

  save = async () => {
    this.setState({ pending: true });
    const items = Object.entries(this.state.list);
    if (items.length > 0) {
      let queries = [];
      items.forEach(([id, item]) => {
        queries.push({
          element: id,
          value: item.value,
          type: 0,
        });
      });
      let result = await this.context.api.qa(
        "/element/operating/time/set",
        queries
      );
      if (result !== false) {
        this.context.toast("Изменения сохранены", "success");
        this.load();
      } else {
        this.context.toast("Не удалось сохранить изменения", "error");
        this.setState({ pending: false });
      }
    }
    this.setState({ pending: false });
  };

  onChange = (id, value) => {
    this.setState((state) => {
      let list = state.list;
      list[id].value = value;
      return { list };
    });
  };

  render() {
    const { list, pending } = this.state;
    const items = Object.entries(list);
    return (
      <>
        <BsModal xl {...this.props}>
          <Blocker on={pending}>
            <h4 className="mb-4">Внесение наработки по оборудованию</h4>
            {items.length > 0 ? (
              <>
                <table className="table">
                  <tbody>
                    {items.map(([id, item]) => {
                      return (
                        <tr key={id} className="bg-hover-light">
                          <td className="valign-center" width="70%">
                            {item.label}
                            <div className="text-dark-50 small">
                              {item.modelname}
                            </div>
                          </td>
                          <td className="valign-center">
                            <input
                              className="form-control"
                              type="number"
                              value={item.value}
                              onChange={(e) =>
                                this.onChange(id, e.target.value)
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <hr />
                <div className="text-right">
                  <button onClick={this.save} className="btn btn-primary">
                    Сохранить
                  </button>
                </div>
              </>
            ) : (
              <DefaultNotFound />
            )}
          </Blocker>
        </BsModal>
      </>
    );
  }
}
